import { formatPhone } from '@/utils/filters';
import { Nullable } from '@/utils/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';
import { MASKED_VALUE } from '@/bundles/BaseTable/helpers/customFieldLinks';

// Label renders a falsy boolean as N/A, which reads as "unknown" rather than "no".
export const formatCustomFieldFlag = (value: Nullable<boolean>): Nullable<string> => {
  return typeof value === 'boolean' ? (value ? 'Yes' : 'No') : null;
};

// An empty list returns null rather than '', so Label shows N/A.
export const formatCustomFieldList = (values: Nullable<string[]>): Nullable<string> => {
  return values?.length ? values.join(', ') : null;
};

export const formatCustomFieldPhone = (value: Nullable<string>): Nullable<string> => {
  return isValuePresent(value) ? formatPhone(value) : null;
};

// "2 Months". No free rent, or 0, reads as N/A.
export const formatCustomFieldFreeRent = (freeRent: Nullable<number | string>, term: Nullable<string>): Nullable<string> => {
  return Number(freeRent) > 0 ? [freeRent, term].filter(Boolean).join(' ') : null;
};

// "(214) 555-0101 Ext: 204", matching how list rows show extensions. A masked (private) number
// gets no extension.
export const formatCustomFieldPhoneWithExt = (value: Nullable<string>, ext: Nullable<string>): Nullable<string> => {
  const phone = formatCustomFieldPhone(value);

  return phone && isValuePresent(ext) && value !== MASKED_VALUE ? `${phone} Ext: ${ext}` : phone;
};
